import React, { useState } from 'react'
import { isValidUrl, verifyExtension } from '../shared/constants'
import ImageDialog from './Dialog/ImageDialog'

export default function ViewImage({ image }) {
  const [open, setOpen] = useState(false)
  const [preview, setPreview] = useState(false)

  return (
    <div>
      {isValidUrl(image) && verifyExtension(image) === 'image' ? (
        <img
          src={image}
          width="150px"
          style={{ marginTop: '10px', cursor: 'pointer' }}
          onClick={() => {
            setOpen(true)
            setPreview(image)
          }}
          alt="pre"
        />
      ) : (
        <video
          src={image}
          width="150px"
          style={{ marginTop: '10px', cursor: 'pointer' }}
          onClick={() => {
            setOpen(true)
            setPreview(image)
          }}
          alt="pre"
        />
      )}
      {preview && <ImageDialog open={open} handleClose={() => setOpen(false)} image={preview} />}
    </div>
  )
}
